<template>
  <div>
    <a-card class="customer-filter" size="small">
      <venue-filter-form :value="filterForm" @change="onSearch" @reset="handleReset" />
    </a-card>
    <a-card title="需求竞拍会场列表" class="filter-data" size="small">
      <span slot="extra">
        <a-button v-has="{ code: 'business:venue:edit' }" v-tc="{ name: '添加会场' }" class="handle-menu" type="primary" icon="plus" @click="onAdd">创建会场</a-button>
      </span>
      <venue-data-list :loading="loading" :table-data="tableData" :pagination="pagination" @page-change="handleTableChange" @edit="onEdit" @delete="onDelete" @reload="getVenueList" />
    </a-card>
    <venue-modal ref="venueModal" @close="getVenueList" />
  </div>
</template>

<script>
import { venueList, venueDelete } from '@/api/business/venue';

import VenueModal from '@/pages/business/venue/components/VenueModal';
import VenueDataList from '@/pages/business/venue/components/VenueDataList';
import VenueFilterForm from '@/pages/business/venue/components/VenueFilterForm';

export default {
  name: 'VenueIndex',
  components: {
    VenueModal,
    VenueDataList,
    VenueFilterForm
  },
  data() {
    return {
      loading: false,
      filterForm: {
        name: null,
        status: null,
        venue_type: null,
        time_field: 'create_time'
      },
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: this.$store.getters.pageSize,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: total => `共 ${total} 条`
      },
      tableData: []
    };
  },
  mounted() {
    this.getVenueList();
  },
  methods: {
    onAdd() {
      this.$nextTick(() => {
        this.$refs.venueModal.openAdd();
      });
    },

    onEdit(record) {
      this.$nextTick(() => {
        this.$refs.venueModal.openEdit(record.id);
      });
    },

    onDelete(record) {
      this.$confirm({
        title: '确定删除此会场吗？',
        content: `会场名称：${record.name}`,
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          return this.deleteVenue(record.id);
        }
      });
    },

    /**
     * 删除会场
     */
    deleteVenue(id) {
      return venueDelete({ id })
        .then(() => {
          this.$message.success('删除成功');
          this.getVenueList();
        })
        .catch(err => {
          this.$message.error(err.message || '删除失败');
        });
    },

    /**
     * 获取会场列表
     */
    getVenueList() {
      this.loading = true;
      venueList({
        ...this.filterForm,
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      })
        .then(res => {
          this.tableData = res.data.items || [];
          this.pagination.total = res.data.total || 0;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handleReset(filter) {
      this.pagination.current = 1;
      this.pagination.pageSize = this.$store.getters.pageSize;
      this.filterForm = filter || {
        name: null,
        status: null,
        venue_type: null,
        time_field: 'create_time'
      };
      this.getVenueList();
    },

    onSearch(filter) {
      this.filterForm = { ...filter };
      this.pagination.current = 1;
      this.getVenueList();
    },

    handleTableChange(pagination) {
      this.pagination = pagination;
      this.getVenueList();
    }
  }
};
</script>

<style lang="less" scoped>
:deep(.customer-filter) {
  .ant-page-header {
    padding: 0;
  }
  margin-bottom: 16px;
}
</style>
